import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaPlus, FaSearch, FaSave, FaTimes } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';

const FaixaLicenciamento = () => {
  const [faixas, setFaixas] = useState([]);
  const [filteredFaixas, setFilteredFaixas] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingFaixa, setEditingFaixa] = useState(null);
  const [formData, setFormData] = useState({
    descricao: '',
    sigla: '',
    faixa: '',
    inicial: '',
    final: '',
    ativo: true
  });
  const [saving, setSaving] = useState(false);

  const faixaOptions = ['Micro', 'Pequeno', 'Médio', 'Grande', 'Especial'];

  const format3 = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const n = Number(value);
    if (!Number.isFinite(n)) return String(value);
    return n.toFixed(3);
  };

  useEffect(() => {
    const fetchFaixas = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/faixa-licenciamento`);
        if (!response.ok) {
          throw new Error('Erro ao buscar faixas de licenciamento');
        }
        const data = await response.json();
        setFaixas(data);
        setFilteredFaixas(data);
      } catch (error) {
        console.error('Erro ao carregar faixas de licenciamento:', error);
      }
    };

    fetchFaixas();
  }, []);

  useEffect(() => {
    const lower = searchTerm.toLowerCase();
    const filtered = faixas.filter((item) =>
      (item.descricao || '').toLowerCase().includes(lower) ||
      (item.sigla || '').toLowerCase().includes(lower) ||
      (item.faixa || '').toLowerCase().includes(lower)
    );
    setFilteredFaixas(filtered);
  }, [searchTerm, faixas]);

  const handleNew = () => {
    setEditingFaixa(null);
    setFormData({
      descricao: '',
      sigla: '',
      faixa: '',
      inicial: '',
      final: '',
      ativo: true
    });
    setShowForm(true);
  };

  const handleEdit = (faixa) => {
    setEditingFaixa(faixa);
    setFormData({
      descricao: faixa.descricao,
      sigla: faixa.sigla,
      faixa: faixa.faixa,
      inicial: faixa.inicial,
      final: faixa.final,
      ativo: faixa.ativo
    });
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    if (!formData.descricao.trim() || !formData.sigla.trim() || !formData.faixa.trim()) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      setSaving(false);
      return;
    }

    const payload = {
      descricao: formData.descricao,
      sigla: formData.sigla,
      faixa: formData.faixa,
      inicial: formData.inicial === '' ? null : parseFloat(formData.inicial),
      final: formData.final === '' ? null : parseFloat(formData.final),
      ativo: formData.ativo
    };

    try {
      if (editingFaixa) {
        const response = await fetch(
          `${API_BASE_URL}/faixa-licenciamento/${editingFaixa.id}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar faixa de licenciamento');
        }

        const updated = await response.json();
        setFaixas((prev) =>
          prev.map((item) => (item.id === editingFaixa.id ? updated : item))
        );
      } else {
        const response = await fetch(
          `${API_BASE_URL}/faixa-licenciamento`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao criar faixa de licenciamento');
        }

        const created = await response.json();
        setFaixas((prev) => [...prev, created]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar faixa de licenciamento:', error);
      alert('Erro ao salvar faixa de licenciamento');
    } finally {
      setSaving(false);
    }
  };

  const resetForm = () => {
    setFormData({
      descricao: '',
      sigla: '',
      faixa: '',
      inicial: '',
      final: '',
      ativo: true
    });
    setEditingFaixa(null);
    setShowForm(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir esta faixa de licenciamento?')) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/faixa-licenciamento/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir faixa de licenciamento');
      }

      setFaixas((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      console.error('Erro ao excluir faixa de licenciamento:', error);
      alert('Erro ao excluir faixa de licenciamento');
    }
  };

  const handleToggleStatus = async (id) => {
    const faixaSelecionada = faixas.find((f) => f.id === id);

    if (!faixaSelecionada) {
      return;
    }

    const novoAtivo = !faixaSelecionada.ativo;

    try {
      const payload = {
        descricao: faixaSelecionada.descricao,
        sigla: faixaSelecionada.sigla,
        faixa: faixaSelecionada.faixa,
        inicial: faixaSelecionada.inicial,
        final: faixaSelecionada.final,
        ativo: novoAtivo
      };

      const response = await fetch(
        `${API_BASE_URL}/faixa-licenciamento/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status da faixa de licenciamento');
      }

      const updated = await response.json();

      setFaixas((prev) =>
        prev.map((item) => (item.id === id ? { ...item, ativo: updated.ativo } : item))
      );
    } catch (error) {
      console.error('Erro ao atualizar status da faixa de licenciamento:', error);
      alert('Erro ao atualizar status da faixa de licenciamento');
    }
  };

  return (
    <div className="nucleos-container">
      {!showForm ? (
        <>
          <div className="tabela-header">
            <div className="header-content">
              <h1>Faixa de Licenciamento Municipal</h1>
            </div>
            <button className="btn-primary" onClick={handleNew}>
              <FaPlus /> Cadastrar Faixa
            </button>
          </div>

          <div className="table-container">
            <div className="table-controls">
              <div className="search-container">
                <FaSearch />
                <input
                  type="text"
                  placeholder="Buscar por descrição, porte ou faixa..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="table-info">
                <span>{filteredFaixas.length} registro(s) encontrado(s)</span>
              </div>
            </div>

            <div className="table-wrapper">
              <table className="data-table nucleos-table">
                <thead>
                  <tr>
                    <th className="col-id">ID</th>
                    <th className="col-nome">Descrição</th>
                    <th className="col-sigla">Porte</th>
                    <th className="col-sigla">Faixa</th>
                    <th className="col-prazo">Inicial</th>
                    <th className="col-prazo">Final</th>
                    <th className="col-status">Status</th>
                    <th className="col-acoes">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredFaixas.map((faixa) => (
                    <tr key={faixa.id}>
                      <td className="col-id">{faixa.id}</td>
                      <td className="col-nome">{faixa.descricao}</td>
                      <td className="col-sigla">
                        <span className="sigla-badge">{faixa.sigla}</span>
                      </td>
                      <td className="col-sigla">{faixa.faixa}</td>
                      <td className="col-prazo">{format3(faixa.inicial)}</td>
                      <td className="col-prazo">{format3(faixa.final)}</td>
                      <td className="col-status">
                        <span className={`status-badge ${faixa.ativo ? 'ativo' : 'inativo'}`}>
                          {faixa.ativo ? 'Ativo' : 'Inativo'}
                        </span>
                      </td>
                      <td className="col-acoes">
                        <div className="action-buttons">
                          <button
                            className="btn-edit"
                            onClick={() => handleEdit(faixa)}
                            title="Editar"
                          >
                            <FaEdit />
                          </button>
                          <button
                            className="btn-delete"
                            onClick={() => handleDelete(faixa.id)}
                            title="Excluir"
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {filteredFaixas.length === 0 && (
                <div className="empty-state">
                  <FaSearch size={48} />
                  <h3>Nenhuma faixa de licenciamento encontrada</h3>
                  <p>Tente ajustar os filtros de pesquisa ou cadastre uma nova faixa.</p>
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingFaixa ? 'Editar Faixa de Licenciamento' : 'Cadastrar Faixa de Licenciamento'}</h2>
          </div>
          
          <form onSubmit={handleSubmit}>
            <div className="form-content">
              <div className="form-row">
                <div className="form-group flex-grow">
                  <label htmlFor="descricao">Descrição *</label>
                  <input
                    type="text"
                    id="descricao"
                    value={formData.descricao}
                    onChange={(e) =>
                      setFormData({ ...formData, descricao: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="sigla">Porte *</label>
                  <input
                    type="text"
                    id="sigla"
                    value={formData.sigla}
                    onChange={(e) =>
                      setFormData({ ...formData, sigla: e.target.value })
                    }
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="faixa">Faixa *</label>
                  <select
                    id="faixa"
                    value={formData.faixa}
                    onChange={(e) =>
                      setFormData({ ...formData, faixa: e.target.value })
                    }
                    required
                  >
                    <option value="">Selecione...</option>
                    {faixaOptions.map((opt) => (
                      <option key={opt} value={opt}>{opt}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="inicial">Inicial</label>
                  <input
                    type="number"
                    id="inicial"
                    value={formData.inicial}
                    onChange={(e) =>
                      setFormData({ ...formData, inicial: e.target.value })
                    }
                    step="0.001"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="final">Final</label>
                  <input
                    type="number"
                    id="final"
                    value={formData.final}
                    onChange={(e) =>
                      setFormData({ ...formData, final: e.target.value })
                    }
                    step="0.001"
                  />
                </div>
              </div>

              <div className="form-group checkbox-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={formData.ativo}
                    onChange={(e) => setFormData({ ...formData, ativo: e.target.checked })}
                  />
                  Ativo
                </label>
              </div>
            </div>

            <div className="form-actions">
              <button
                type="button"
                className="btn-secondary"
                onClick={resetForm}
              >
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="btn-primary" disabled={saving}>
                <FaSave /> {saving ? 'Salvando...' : (editingFaixa ? 'Atualizar' : 'Cadastrar')}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default FaixaLicenciamento;
